import Form from "../../../components/Forms/UserForm";
import {
  selectActiveUser,
  selectStudents,
  selectUsersLoading,
} from "../../../store/selectors/userSelector";
import { useAppSelector, useAppThunkDispatch } from "../../../store/hooks";
import { ROLES, Student } from "../../../types/user";
import { PermissionControl } from "../../../components/Permission";
import { permissions } from "../../../utils/permissions";
import { getRole } from "../../../services/api/utils.api";
import { getActiveUser } from "../../../store/actions/userActions";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchUser } from "../../../services/api/users.api";
import AlertDialog from "../../../components/Alert";
import { handleApiError } from "../../../utils/handleApiError";
import Loading from "../../../components/Loading";

const UserFormPage = () => {
  const { id } = useParams();
  const dispatch = useAppThunkDispatch();
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  console.log(id);

  const fetchData = (data: string) => {
    setIsLoading(true);
    fetchUser("student", data)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((e) => {
        handleApiError(e, setError);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    id && fetchData(id);
  }, [id]);

  useEffect(() => {
    if (data) {
      if (data && data.role === undefined) {
        console.log("enrichdata", data);

        const enrichedStudent: Student = {
          ...data,
          username: data._id,
          role: "student",
          schools: [data.school! || data.schools || ""],
        };
        delete enrichedStudent.school;
        console.log("Student: ", enrichedStudent);
        dispatch(getActiveUser(enrichedStudent));
      } else {
        data && dispatch(getActiveUser(data));
      }
    }
  }, [data]);

  if (isLoading) return <Loading />;

  return (
    <PermissionControl
      permissionPath={permissions.pages.players.update}
      role={getRole()}
    >
      <Form role={ROLES.STUDENT} />
      {error && (
        <AlertDialog
          title={"System Error"}
          message={error || ""}
          buttons={[
            {
              label: "Ok",
              onClick: () => {
                setError(undefined);
              },
            },
          ]}
        />
      )}
    </PermissionControl>
  );
};
export default UserFormPage;
